import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";
import { CardVector } from "../../type";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    matchCard: builder.mutation<
      {
        fullText: string;
        success: boolean;
        detectedText: string;
        language: string;
        bestMatch: CardVector & { similarity: number };
        allCandidates: CardVector & { similarity: number }[];
      },
      FormData
    >({
      query: (formData) => ({
        url: `${BASE_SERVER_PATH}/api/card-reconizer/match-card`,
        method: "POST",
        body: formData,
        headers: {
          "x-requires-auth": "true",
          // Do NOT set 'Content-Type': let browser set it for FormData
        },
      }),
    }),
  }),
});

export const { useMatchCardMutation } = myServerApis;
